import type {
  PlannerEntriesResponse,
  PlannerEntry,
  PlannerEntryInput,
  PlannerEntryResponse,
  Trip,
  TripInput,
  TripResponse,
  TripsResponse,
} from '../../shared/planner';
import { readError } from './api';

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
      ...init?.headers,
    },
    ...init,
  });
  if (!response.ok) throw new Error(await readError(response));
  return (await response.json()) as T;
}

export async function listPlannerEntries(): Promise<PlannerEntry[]> {
  return (await request<PlannerEntriesResponse>('/api/planner')).entries;
}

export async function createPlannerEntry(input: PlannerEntryInput): Promise<PlannerEntry> {
  return (
    await request<PlannerEntryResponse>('/api/planner', {
      method: 'POST',
      body: JSON.stringify(input),
    })
  ).entry;
}

export async function setPlannerStatus(
  id: string,
  status: PlannerEntry['status'],
): Promise<PlannerEntry> {
  return (
    await request<PlannerEntryResponse>(`/api/planner/${encodeURIComponent(id)}`, {
      method: 'PATCH',
      body: JSON.stringify({ status }),
    })
  ).entry;
}

export async function deletePlannerEntry(id: string): Promise<void> {
  await request(`/api/planner/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export async function listTrips(): Promise<Trip[]> {
  return (await request<TripsResponse>('/api/trips')).trips;
}

export async function createTrip(input: TripInput): Promise<Trip> {
  return (
    await request<TripResponse>('/api/trips', {
      method: 'POST',
      body: JSON.stringify(input),
    })
  ).trip;
}

export async function setTripItemPacked(
  id: string,
  garmentId: string,
  packed: boolean,
): Promise<Trip> {
  return (
    await request<TripResponse>(`/api/trips/${encodeURIComponent(id)}`, {
      method: 'PATCH',
      body: JSON.stringify({ garmentId, packed }),
    })
  ).trip;
}

export async function deleteTrip(id: string): Promise<void> {
  await request(`/api/trips/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
